import dynamic from 'next/dynamic';
import { AddToCalendarProps } from './AddToCalendarModal.types';

export const AddtoCalendarModalMGP = dynamic<AddToCalendarProps>(() => import('./AddToCalendarModal'));
